export default __webpack_public_path__ + "static/media/progress.3460f584.svg";